import type { LegacyRiskGapStatus } from '@ctw/shared/api/fhir/models/risk-gap';

export const isOpenGap = (status: LegacyRiskGapStatus) => status === 'open-gap';
